import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
// import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

import * as Yup from "yup";
import { useFormik } from "formik";

import { Label, MultiSelect, Button } from "@/components/ui";

import { SheetFilterContainer } from "../../sheets";
import { useFetchRolesQuery, useToast } from "@/hooks";
import { DisplayError } from "@/utils";

type FormFilterCollaboratorProps = PropsWithChildren;

export function FormFilterCollaborator({
  children,
}: FormFilterCollaboratorProps) {
  const { t } = useTranslation();
  const { toast } = useToast();

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { data: rolesData, isLoading: isLoadingRoles } = useFetchRolesQuery({});

  const initialValues = {
    status: "1",
    roleId: "",
  };

  const {
    handleSubmit,
    errors,
    touched,
    isSubmitting,
    resetForm,
    ...formik
  } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      status: Yup.string().optional(),
      roleId: Yup.string().optional(),
    }),

    onSubmit: async (data) => {
      await handleFilterCollaborator(data);
    },
  });

  async function handleFilterCollaborator(values: any) {
    try {
      if (values.status) queryParams.set("status", values.status);
      if (values.roleId) queryParams.set("roleId", values.roleId);
      navigate({ search: queryParams.toString() });
    } catch (error) {
      toast({
        title: t("LABEL.error"),
        description: DisplayError(error),
        variant: "destructive",
      });
    }
  }

  function clearFilter() {
    queryParams.delete("status");
    queryParams.delete("roleId");

    navigate({ search: queryParams.toString() });
    resetForm();
  }
  return (
    <SheetFilterContainer button={children}>
      <div className="h-full overflow-y-auto pb-5 px-1">
        <form onSubmit={handleSubmit} className="space-y-8">
          <div className="space-y-6">
            {/* <div className="space-y-5">
              <Label>{t("LABEL.status")}</Label>

              <RadioGroup
                defaultValue="1"
                className="space-y-2"
                {...getFieldProps("status")}
                onValueChange={(value) => {
                  formik.setFieldValue("status", value);
                }}
              >
                <div className="flex items-center space-x-2 text-zinc-600">
                  <RadioGroupItem value="1" id="1" />
                  <Label htmlFor="1">{t("LABEL.active")}</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="0" id="0" />
                  <Label htmlFor="0">{t("LABEL.inactive")}</Label>
                </div>
              </RadioGroup>
            </div> */}

            <div className="space-y-1">
              <Label>{t("LABEL.role")}</Label>
              <MultiSelect
                options={
                  rolesData?.items.map((role) => ({
                    value: role.id,
                    label: role.name,
                  })) || []
                }
                loading={isLoadingRoles}
                isInvalid={touched.roleId && errors.roleId}
                isValid={touched.roleId && !errors.roleId}
                placeholder={t("LABEL.select a role")}
                emptyMessage={t("no results")}
                width="300px"
                value={formik.values.roleId}
                onChange={(value) => formik.setFieldValue("roleId", value)}
              />
            </div>
          </div>
          <div className="flex justify-start gap-2">
            <Button
              type="submit"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Filtrar
            </Button>
            <Button variant="secondary" type="button" onClick={clearFilter}>
              Limpar filtro
            </Button>
          </div>
        </form>
      </div>
    </SheetFilterContainer>
  );
}
